import { gql } from '@apollo/client';
import { JOB_FRAGMENT } from './jobs';

export const GET_JOB_OFFER_TEMPLATES = gql`
    query GetJobOfferTemplates($query: String, $filter: JobOfferFilter, $sortBy: String, $pagination: Pagination) {
        getJobOfferTemplatesPro(query: $query, filter: $filter, sortBy: $sortBy, pagination: $pagination) {
            docs {
                ...jobFragment
            }
            meta {
                page
                totalPages
                totalDocs
                nextPage
                prevPage
                limit
            }
        }
    }
    ${JOB_FRAGMENT}
`;

export const GET_JOB_OFFER_TEMPLATES_UPERCUT = gql`
    query GetJobOfferTemplatesUpercut($query: String, $filter: JobOfferFilter, $sortBy: String, $pagination: Pagination) {
        getJobOfferTemplatesUpercut(query: $query, filter: $filter, sortBy: $sortBy, pagination: $pagination) {
            docs {
                ...jobFragment
            }
            meta {
                page
                totalPages
                totalDocs
                nextPage
                prevPage
                limit
            }
        }
    }
    ${JOB_FRAGMENT}
`;

export const GET_JOB_OFFER_TEMPLATE = gql`
    query GetJobOfferTemplate($_id: ID, $jobNumber: String) {
        getJobOfferTemplatePro(_id: $_id, jobNumber: $jobNumber) {
            ...jobFragment
        }
    }
    ${JOB_FRAGMENT}
`;

export const GET_JOB_OFFER_TEMPLATE_UPERCUT = gql`
    query GetJobOfferTemplateUpercut($_id: ID, $jobNumber: String) {
        getJobOfferTemplateUpercut(_id: $_id, jobNumber: $jobNumber) {
            ...jobFragment
        }
    }
    ${JOB_FRAGMENT}
`;

export const ADD_JOB_OFFER_TEMPLATE = gql`
    mutation AddJobOfferTemplate($templateInput: JobOfferInput) {
        addJobOfferTemplatePro(templateInput: $templateInput) {
            _id
            jobNumber
        }
    }
`;

export const ADD_JOB_OFFER_TEMPLATE_UPERCUT = gql`
    mutation AddJobOfferTemplateUpercut($templateInput: JobOfferInput, $proId: ID) {
        addJobOfferTemplateUpercut(templateInput: $templateInput, proId: $proId) {
            _id
            jobNumber
        }
    }
`;

export const UPDATE_JOB_OFFER_TEMPLATE = gql`
    mutation UpdateJobOfferTemplate($templateInput: JobOfferInput) {
        updateJobOfferTemplatePro(templateInput: $templateInput) {
            _id
            jobNumber
        }
    }
`;

export const UPDATE_JOB_OFFER_TEMPLATE_UPERCUT = gql`
    mutation UpdateJobOfferTemplateUpercut($templateInput: JobOfferInput) {
        updateJobOfferTemplateUpercut(templateInput: $templateInput) {
            _id
            jobNumber
        }
    }
`;

export const DELETE_JOB_OFFER_TEMPLATE = gql`
    mutation DeleteJobOfferTemplate($_id: ID!) {
        deleteJobOfferTemplatePro(_id: $_id) {
            _id
        }
    }
`;

export const SEARCH_JOB_OFFER_TEMPLATE_FILTERS = gql`
    query SearchJobOfferTemplateFilters($query: String, $filter: JobOfferFilter) {
        searchJobOfferTemplateFilters(query: $query, filter: $filter) {
            proIds {
                value
                label
                count
            }
            brandIds {
                value
                label
                count
            }
        }
    }
`;
